import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core';
import styles from '../AppQRCode/styles';

class VehicleCapability extends React.PureComponent {
  render() {
    const { t, classes } = this.props;
    return (
      <React.Fragment>
        <div className={classes.errorMessage}>{t('welcome.vehicle_error')}</div>
        <div className={classes.errorMessage_info}>{t('welcome.vehicle_error_info')}</div>
      </React.Fragment>
    );
  }
}

VehicleCapability.propTypes = {
  t: PropTypes.any.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(VehicleCapability));
